import "core-js/fn/object";
import {CriptografiaUtil} from "../../util/criptografiaUtil";

function logar(event: Event): void {
    event.preventDefault();
    const lembrarme = document.getElementById('lembrarMe') as HTMLInputElement | null;
    const login = document.getElementById('loginUsuario') as HTMLInputElement;
    const senha = document.getElementById('senhaUsuario') as HTMLInputElement;

    let loginCriptografado = CriptografiaUtil.criptografar(login.value);
    let senhaCriptografada = CriptografiaUtil.criptografar(senha.value);

    let formData = new FormData();
    formData.append("login", loginCriptografado.toString());
    formData.append("senha", senhaCriptografada.toString());
    formData.append("lembrarMe", lembrarme.checked.toString());

    $.ajax({
        url: ("login/logar"),
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        cache: false,
        success: function(data) {
            if(data.includes('dashboard/')||data.includes('tabelaIndicadores/form/')) {
                window.location.href = data;
            } else {
                var divOcultaValidacaoLogin = $(data).find('.login-form-links.logout');
                var mensagemLoginDiv = $('#MensagemLogin');
                if (mensagemLoginDiv.length > 0) {
                    mensagemLoginDiv.replaceWith(divOcultaValidacaoLogin);
                } else {
                    $('.login-content').append(divOcultaValidacaoLogin);
                }
            }
        }
    }).done(function(data) {
        window.location.href = data;
    });
}

const botaoEntrar = document.getElementById('btnLogar');

if (botaoEntrar) {
    botaoEntrar.addEventListener('click', logar);
}


// WEBPACK FOOTER //
// ./src/modulos/login/login.ts